<div class="health-status-widget" role="region">
  <ng-container *ngIf="viewModel$ | async as vm">
    <div class="widget-header">
      <div class="widget-header-leading">
        <span class="overall-label">Nossos serviços estão:</span>
        <span *ngIf="vm.healthStatus" [class]="'overall-badge ' + getOverallStatusClass(vm.healthStatus)" [attr.aria-label]="'Status geral: ' + (vm.healthStatus.overall_status === 'ok' ? 'OK' : vm.healthStatus.overall_status === 'degraded' ? 'Degradado' : 'Indisponível')">
          {{ vm.healthStatus.overall_status === 'ok' ? 'OK' : vm.healthStatus.overall_status === 'degraded' ? 'Degradados' : 'Indisponíveis' }}
        </span>
        <span *ngIf="!vm.healthStatus && !vm.isConnected" class="overall-badge status-unknown" aria-live="polite">Conectando...</span>
        <span *ngIf="!vm.healthStatus && vm.isConnected" class="overall-badge status-unknown" aria-live="polite">Aguardando status</span>
      </div>
      <app-button class="refresh-btn" [icon]="primeIcon.REFRESH" [variant]="ButtonVariant.SECONDARY" [color]="buttonColor.NEUTRAL_LIGHT" [scale]="ButtonScale.EXTRA_SMALL" label="Atualizar" [callback]="requestCurrentStatus.bind(this)"></app-button>
    </div>
    <ul *ngIf="vm.serviceEntries.length" class="services-list">
      <li *ngFor="let entry of vm.serviceEntries" class="service-item">
        <span class="service-name">{{ getServiceDisplayName(entry[0]) }}</span>
        <span [class]="'service-badge ' + getServiceStatusClass(entry[1].status)">{{ entry[1].status }}</span>
        <span *ngIf="entry[1].response_time_ms != null" class="service-latency">{{ entry[1].response_time_ms }} ms</span>
        <span *ngIf="entry[1].error" class="service-error" [title]="entry[1].error">{{ entry[1].error }}</span>
      </li>
    </ul>
  </ng-container>
</div>
